import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tag", "hiddenContainer", "counter", "submitBtn", "error", "card"]
  static values = {
    max: { type: Number, default: 3 },
    min: { type: Number, default: 0 },
    fieldName: String,
    submitBtnId: String,
    requireOnSubmit: { type: Boolean, default: false }
  }

  connect() {
    this.selected = new Set()
    this.renderCounter()
    this.updateSubmitBtn()
    this.form = this.element.closest("form") || this.element.querySelector("form")
    this._submitHandler = (event) => this.validateOnSubmit(event)
    if (this.form) this.form.addEventListener("submit", this._submitHandler)
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("submit", this._submitHandler)
  }

  toggle(event) {
    const btn = event.currentTarget
    const key = btn.dataset.tagKey

    if (this.selected.has(key)) {
      this.selected.delete(key)
      this.deactivate(btn)
    } else {
      if (this.selected.size >= this.maxValue) return
      this.selected.add(key)
      this.activate(btn)
    }

    this.syncHiddenInputs()
    this.renderCounter()
    this.updateSubmitBtn()
    this.hideError()
  }

  updateSubmitBtn() {
    if (this.requireOnSubmitValue) return

    const btn = this.hasSubmitBtnTarget
      ? this.submitBtnTarget
      : (this.submitBtnIdValue ? document.getElementById(this.submitBtnIdValue) : null)
    if (!btn) return
    const valid = this.selected.size >= this.minValue
    btn.disabled = !valid
    btn.style.opacity = valid ? "1" : "0.4"
    btn.style.cursor = valid ? "pointer" : "not-allowed"
  }

  activate(btn) {
    btn.style.background = "#EEF2FF"
    btn.style.borderColor = "#6366F1"
    btn.style.color = "#4338CA"
  }

  deactivate(btn) {
    btn.style.background = "#FFFFFF"
    btn.style.borderColor = "#E5E7EB"
    btn.style.color = "#374151"
  }

  syncHiddenInputs() {
    const container = this.hiddenContainerTarget
    container.innerHTML = ""
    this.selected.forEach(key => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = this.fieldNameValue
      input.value = key
      container.appendChild(input)
    })
  }

  renderCounter() {
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.selected.size}/${this.maxValue}`
    }
  }

  validateOnSubmit(event) {
    if (!this.requireOnSubmitValue || this.minValue <= 0) return

    if (this.selected.size < this.minValue) {
      event.preventDefault()
      const fallbackMessage = `${this.minValue}개 이상 선택해주세요.`
      const message = this.hasErrorTarget && this.errorTarget.textContent.trim().length > 0
        ? this.errorTarget.textContent.trim()
        : fallbackMessage
      this.showError(message)
      this.element.scrollIntoView({ behavior: "smooth", block: "center" })
      return
    }

    this.hideError()
  }

  showError(message) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.style.display = "block"
    if (this.hasCardTarget) this.cardTarget.style.borderColor = "#EF4444"
  }

  hideError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = ""
    this.errorTarget.style.display = "none"
    if (this.hasCardTarget) this.cardTarget.style.borderColor = "#E5E7EB"
  }
}
